import { ITransaction, ITransactions } from '@interfaces/transaction';
import { DateTime } from 'luxon';
import { DATE_TIME_FORMAT } from '@constants/date-time.constants';

export const groupTransactionsByDate = (transactions: ITransaction[] = []) => {
	const result: {
		[key: string]: ITransactions<ITransaction>;
	} = {};
	let amount = 0;
	transactions.forEach((txn) => {
		const date = DateTime.fromJSDate(new Date(txn.createdAt) as Date).toFormat(DATE_TIME_FORMAT);
		if (result[date]) {
			result[date]?.transactions.push(txn);
			result[date].amount = (result[date]?.amount ?? 0) + txn.amount;
		} else {
			result[date] = {
				transactions: [txn],
				amount: txn.amount ?? 0,
				createdAt: date,
			};
		}
		amount += txn.amount;
	});
	const transactionsGroup = Object.values(result);
	return { amount, transactionsGroup };
};

export const ungroupTransactionsByDate = (transactionsGroup: ITransactions<ITransaction>[]) => {
	const transactions: ITransaction[] = [];
	transactionsGroup.forEach((group) => {
		group.transactions.forEach((txn) => {
			transactions.push(txn);
		});
	});
	return transactions;
};

export const markNewTransactionAsOld = (transactions: ITransaction[], existingTxns: ITransaction[]) => {
	return transactions.map((transaction) => {
		if (transaction.isNew) {
			for (const existingTxn of existingTxns) {
				if (existingTxn._id === transaction._id && !existingTxn.isNew) {
					transaction.isNew = false;
					break;
				}
			}
		}
		return transaction;
	});
};
